import { Link } from "wouter";
import { ArrowRight, Truck } from "lucide-react";
import { Reveal } from "@/components/home/reveal";

const STEPS = [
  { k: "Sell", d: "Equipment for homes and businesses" },
  { k: "Supply", d: "Supply-only for trade customers" },
  { k: "Install", d: "Complete installation by our engineers" },
];

export function WarehouseStock() {
  return (
    <section id="warehouse-stock" aria-labelledby="warehouse-stock-title" className="relative py-14 lg:py-20 bg-[hsl(var(--vx-ink))] text-white overflow-hidden">
      <div className="absolute inset-0 vx-grid-lines pointer-events-none" aria-hidden="true" />
      <div className="relative container mx-auto max-w-7xl px-4">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-16 items-center">
          <Reveal>
            <p className="vx-eyebrow text-[hsl(var(--vx-frost))] mb-4">02 — Sell · Supply · Install</p>
            <h2 id="warehouse-stock-title" className="vx-display text-4xl md:text-6xl font-bold mb-6">Our air conditioning stock</h2>
            <p className="text-lg text-white/70 leading-relaxed mb-8">
              Air conditioning equipment for homes, businesses and trade customers.
              Whether you need supply only or a complete installation, speak to our team
              about the right system and current stock availability.
            </p>
            <ol className="grid grid-cols-3 gap-px rounded-2xl overflow-hidden bg-white/10 mb-8">
              {STEPS.map((s, i) => (
                <li key={s.k} className="bg-[hsl(var(--vx-ink-2))] p-4">
                  <span className="text-xs text-white/40 font-display">0{i + 1}</span>
                  <p className="font-display text-xl font-bold mt-1">{s.k}</p>
                  <p className="text-xs text-white/55 mt-1 leading-snug">{s.d}</p>
                </li>
              ))}
            </ol>
            <div className="flex gap-4 rounded-2xl bg-white text-[hsl(var(--vx-ink))] p-5 mb-8">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-[hsl(var(--vx-ember))] text-white shrink-0" aria-hidden="true">
                <Truck className="w-5 h-5" />
              </span>
              <div>
                <p className="font-semibold">Guaranteed next-day delivery when stock is available</p>
                <p className="text-sm text-slate-600 mt-1">Applies to equipment delivery. Installation dates are arranged separately.</p>
              </div>
            </div>
            <Link href="/contact" className="group inline-flex items-center gap-2 h-13 py-3.5 px-7 rounded-full bg-[hsl(var(--vx-frost))] text-[hsl(var(--vx-ink))] font-semibold transition-transform hover:-translate-y-0.5 motion-reduce:transform-none" data-testid="link-enquire-stock">
              Enquire about stock <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true" />
            </Link>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="relative">
              <img
                src={`${import.meta.env.BASE_URL}images/warehouse-stock.webp`}
                alt="Air conditioning warehouse stock with boxed Fujitsu units and indoor and outdoor systems on pallets."
                width={1536}
                height={1024}
                loading="lazy"
                className="w-full h-auto rounded-[1.75rem] ring-1 ring-white/10"
              />
              <div className="absolute -bottom-5 left-6 rounded-full bg-white text-[hsl(var(--vx-ink))] px-5 py-2.5 text-sm font-semibold shadow-xl">
                Homes · Businesses · Trade
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
